import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppContext } from '../AppContext';
import "croppie/croppie.css";
import Croppie from "croppie";
import { RecordEvent } from '../Analytics';

class Step2IMG extends React.Component {

    constructor(props) {

        super(props);

        this.resize = null;
        this.initResize = null;
        this.feedback = null;

        this.state = {
            file: [],
            efile: [],
            blob: [],
            pos: 0
          };
    
        this.rotateImg = this.rotateImg.bind(this);

        this.addImage = this.addImage.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.editImage = this.editImage.bind(this);
        this.acceptImage = this.acceptImage.bind(this);
        this.submitVideo = this.submitVideo.bind(this);
    }

    async addImage(event, pos) {

        var self = this;
        document.getElementById('submitPhoto').classList.remove("unclickable");
        if (this.state.file.length < 6) {
            var url = URL.createObjectURL(event.target.files[0]);
            var newimg = [url];
            var newFile = newimg.concat(this.state.file);            
            
            var c = document.getElementById('itemtemp');
            this.initResize.bind({
                url: url
            }).then( () => {
                console.log("Loaded image...");

                self.initResize.result({
                    type: 'blob',
                    size: {
                        height: 1024
                    },
                    format: 'png'
                }).then(function (blob, original) {
        
                    console.log("Converted image...");
                    
                    var blobURL = URL.createObjectURL(blob);
                    var newEFile = [blobURL].concat(self.state.efile);
                    var newBlob = [blob].concat(self.state.blob);
                    console.log("two");
                    console.log(newBlob);
                    self.setState({
                        file: newFile,
                        efile: newEFile,
                        blob: newBlob
                    });
                });        
            });

            // fetch(url)
            // .then(res => res.blob()) // Gets the response and returns it as a blob
            // .then(blob => {
            //     var newBlob = [blob].concat(self.state.blob);
            //     console.log("two");
            //     console.log(newBlob);
            //     self.setState({
            //         file: newFile,
            //         efile: newEFile,
            //         blob: newBlob
            //     })
         
            // });          
            
        }

        if (this.state.file.length === 5) {
            var firstSelect = document.getElementById('uplaoder');
            firstSelect.classList.add("hidden");
        }
    }

    deleteImage() {

        document.getElementById('model-edit').classList.add("hidden");

        var oldFile = [...this.state.file];
        oldFile.splice(this.state.pos, 1);
        this.setState({file: oldFile});

        var oldEFile = [...this.state.efile];
        oldEFile.splice(this.state.pos, 1);
        this.setState({efile: oldEFile});

        var oldBlob = [...this.state.blob];
        oldBlob.splice(this.state.pos, 1);
        this.setState({blob: oldBlob});

        var firstSelect = document.getElementById('uplaoder');
        firstSelect.classList.remove("hidden");
    }

    editImage(item, poss) {
        
        var self = this;

        document.getElementById('model-edit').classList.remove("hidden");
        this.setState({pos: poss})
        
        this.resize.bind({url: self.state.file[poss]});
    }

    acceptImage() {

        var self = this;
        var oldEFile = [...this.state.efile];
        var oldBlob = [...this.state.blob];
        var pos = this.state.pos;
        self.resize.result({
            type: 'blob',
            size: {
                height: 1024
            },
            format: 'png'
        }).then(function (blob, original) {

                var url = URL.createObjectURL(blob);

                oldEFile.splice(pos, 1, url);
                oldBlob.splice(pos, 1, blob);
                self.setState({ 
                    efile: oldEFile,
                    blob: oldBlob
                });
        });        
       
        document.getElementById('model-edit').classList.add("hidden");  
    }
  
    componentDidMount() {
     
        this.feedback = document.getElementById("feedback");

        var c = document.getElementById('item');
        
        if (c) {
            this.resize = new Croppie(c, {
                enableExif: true,
                viewport: {
                
                    width: 192,
                    height: 341,
                    type: 'square'
                },
                boundary: {
                    width: 222,
                    height: 371
                },
                showZoomer: true,
                enableResize: false,
                enableOrientation: true                
            });
        }

        c = document.getElementById('itemtemp');
        if (c) {
            c.style="position:fixed; left:3840px; top:3840px;"
            this.initResize = new Croppie(c, {
                enableExif: true,
                viewport: {
                    width: 192,
                    height: 341,
                    type: 'square'
                },
                boundary: {
                    width: 222,
                    height: 371
                },
                showZoomer: false,
                enableResize: false,
                enableOrientation: true                
            });
        }
    }

    rotateImg() {
        this.resize.rotate(90);
    }

    submitVideo() {

        this.context.images = [...this.state.blob];
        console.log(this.state.blob);
        this.props.history.push('step3img');
    }

    render() {

        return (
            <div>
                <img src="img/texture1.png" className="backgroundfill" alt=""/>
                <div className="side-menu ">
                    <div className="cover"></div>
                    <div className="step-menu-con">
                        <img src="img/sid-menu-img.png" alt="exsample gif" srcSet="" className="side-menu-top"/>
                        <div className="center-gold"></div>
                        <h1 >thank you lord</h1>
                        <h3>enhanced video</h3>

                        <div className="textcon">
                            <p>Join Chris Tomlin, Thomas Rhett, and Florida Georgia Line in a :25 clip from “Thank You Lord”!</p>
                            <div className="center-gold"></div>
                        </div>

                        <div className="listcon">
                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber"><img className="stepimg check" src="img\check.svg" alt=""/></div>
                                </div>
                                <h2 className="step-title">tell us what you’re thankful for!</h2>
                            </div>

                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber">2</div>
                                </div>
                                <h2 className="step-title"> Show what you are thankful for</h2>
                            </div>

                            <div className="con">
                                <div className="step">
                                    <div className="stepnumber">3</div>
                                </div>
                                <h2 className="step-title"> get your custom music video!</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="body-con step2">
                    <br/>
                    <div className="current-step">
                        <div className="line-before"></div>
                        <div className="con step-con">
                            <div className="step">
                                <div className="stepnumber">2</div>
                            </div>
                        </div>
                        <div className="line-after"></div>
                    </div>



                    <h1 className="main-color step2hed">
What does Thankful <br/> look like to you
</h1>
<br/>

<br className="deskhidden"/>
<div id="uploadPhoto">
                        <p className="textcon ios">Upload up to 6 photos</p>


                    

                        <div className="flex-con">

                        




</div>  
<p/>

<div className="img-gallery">
<div className="fulledit"></div>
<div id="model-edit" className="model-edit hidden">
<div id="item" className=""></div>

<div className="flex-con">
<div id="rotate"  className=" next-button-con inline-but small " 
                                onClick={this.rotateImg} data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:RotateImg'>
    <div className="next-button">
        <div className="nexr-button-innercon">
            
            <div className="next-button-text file11-text"> Rotate </div>
        </div>
    </div>
</div>

<div id="delete"  className=" next-button-con inline-but small " 
                                onClick={ () => this.deleteImage() } data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:RotateImg'>
    <div className="next-button">
        <div className="nexr-button-innercon">
            
            <div className="next-button-text file11-textd"> delete </div>
        </div>
    </div>
</div>

</div>
<div className="flex-con">
<div id="subthis"  className=" next-button-con inline-but full" 
                               >
    <div className="next-button"  onClick={ () => this.acceptImage()}>
        <div className="nexr-button-innercon">
            
            <div className="next-button-text file11-text"> accept </div>
        </div>
    </div>
</div>
</div>
</div>



<div id="uplaoder" className="select-button next-button-con inline-but full-height">
<label htmlFor="file-1" >
    <div className="next-button imgage-con">
        <div className="nexr-button-innercon noflex">
        <div className="imagecon-inline"><div className="circle-add">
            
        <div className="plus"><img src="img/plus.svg" alt=""/></div>
            
            </div></div>
<div className="imagecon-button"> ADD </div>

            <input type="file" name="file-1[]" id="file-1" onChange={ this.addImage } className="inputfile inputfile-1" accept="image/*" 
                            />

       
        </div>
    </div>
    </label>
</div>



{(this.state.efile).map(item => (
         


<div key={item} onClick={ () => this.editImage(item, this.state.efile.indexOf(item)) } className="select-button next-button-con inline-but full-height images-for-uplaod" >

    <div className="next-button imgage-con" >
        <div className="nexr-button-innercon noflex clicker" >
        <div className="imagecon-inline"><img className="iamgefull" src={item} /><div className="circle-add">
            
        <div className="plus"><img src="img/plus.svg" alt=""/></div>
            
            </div></div>
<div className="imagecon-button"  > EDIT  </div>


       
        </div>
    </div>
  
</div>




          ))} 
</div>

<br/>
<br/>
<br/>
<div id="submitPhoto" className="next-button-con next two unclickable" onClick={this.submitVideo} 
                                data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:Step2-SubmitVideo'>
                            <div className="line-before"></div>
                            <div className="next-button">
                                <div className="nexr-button-innercon">
                                    <div className="next-button-text">Next</div>
                                    <div className="next-button-arrow"><img src="img/arrow-right.svg" alt=""/></div>
                                </div>
                            </div>
                            <div className="line-after"></div>
                        </div>
                     
                      
</div>

<br />

                </div>
                <div id="itemtemp"></div>
            </div>
            
        );
    }
}

Step2IMG.contextType = AppContext;
export default withRouter(Step2IMG);